import { createSelector } from "@reduxjs/toolkit";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

/**
 * The previewed variation's mods that the merchant has NOT hidden.
 *
 * The single chokepoint before conversion: onsite edits and onsite injections
 * are excluded by the same rule. Hidden mods still exist in `mods` and still
 * ship to shoppers — this is the merchant's own view only.
 *
 * The complement of `getHiddenVariationMods`.
 */
export const getVisibleVariationMods = createSelector(
  getVariationMods,
  experienceBuilderSlice.selectors.getHiddenModIds,
  (variationMods, hiddenModIds) =>
    variationMods.filter((mod) => !hiddenModIds[mod.id])
);
